import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/ru";
dayjs.extend(utc);
dayjs.locale("ru");
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
export default dayjs;
